import React from "react";
import { PublicShell } from "./PublicShell";
import { SITE } from "@/constants/site";
import { Mail, Phone, MapPin, Map, Facebook, Instagram, Youtube } from "lucide-react";

const socials = [
  { icon: Facebook, label: "Facebook", href: SITE.social.facebook },
  { icon: Instagram, label: "Instagram", href: SITE.social.instagram },
  { icon: Youtube, label: "YouTube", href: SITE.social.youtube },
];

export default function Contact() {
  return (
    <PublicShell
      title="Kontak Kami"
      subtitle="Hubungi kami untuk pertanyaan, bantuan, atau informasi lebih lanjut."
    >
      <div className="grid gap-4 not-prose" data-testid="contact-info">
        <a
          href={`mailto:${SITE.email}`}
          data-testid="contact-email"
          className="flex items-start gap-4 p-5 rounded-xl border border-stone-200 bg-white hover:border-emerald-300 transition-colors"
        >
          <span className="p-2.5 rounded-lg bg-emerald-50 text-emerald-700"><Mail size={20} /></span>
          <span>
            <span className="block text-xs uppercase tracking-wide text-stone-400 font-semibold">Email</span>
            <span className="block text-stone-900 font-medium">{SITE.email}</span>
          </span>
        </a>

        <a
          href={`https://wa.me/${SITE.phoneRaw}`}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-phone"
          className="flex items-start gap-4 p-5 rounded-xl border border-stone-200 bg-white hover:border-emerald-300 transition-colors"
        >
          <span className="p-2.5 rounded-lg bg-emerald-50 text-emerald-700"><Phone size={20} /></span>
          <span>
            <span className="block text-xs uppercase tracking-wide text-stone-400 font-semibold">Telepon / WhatsApp</span>
            <span className="block text-stone-900 font-medium">{SITE.phone}</span>
            <span className="block text-stone-500 text-sm">a.n. {SITE.waName}</span>
          </span>
        </a>

        <div
          data-testid="contact-address"
          className="flex items-start gap-4 p-5 rounded-xl border border-stone-200 bg-white"
        >
          <span className="p-2.5 rounded-lg bg-emerald-50 text-emerald-700"><MapPin size={20} /></span>
          <span>
            <span className="block text-xs uppercase tracking-wide text-stone-400 font-semibold">Alamat Usaha</span>
            <span className="block text-stone-900 font-medium">{SITE.name}</span>
            <span className="block text-stone-600 text-sm mt-1">{SITE.address}</span>
            <a
              href={SITE.mapUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 text-sm text-emerald-700 hover:text-emerald-900 mt-2 font-medium"
            >
              <Map size={15} /> Lihat di Google Maps
            </a>
          </span>
        </div>
      </div>

      <div className="mt-8 not-prose">
        <p className="text-sm font-semibold text-stone-500 mb-3">Media Sosial</p>
        <div className="flex flex-wrap gap-3">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-stone-200 bg-white text-stone-700 hover:border-emerald-300 hover:text-emerald-700 transition-colors text-sm"
            >
              <s.icon size={16} /> {s.label}
            </a>
          ))}
          <a
            href={SITE.social.tiktok}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-stone-200 bg-white text-stone-700 hover:border-emerald-300 hover:text-emerald-700 transition-colors text-sm"
          >
            TikTok
          </a>
        </div>
      </div>

      <div className="mt-8 p-5 rounded-xl bg-emerald-50 border border-emerald-100 not-prose">
        <p className="text-sm text-emerald-900">
          <strong>Jam Layanan:</strong> Senin–Sabtu, 08.00–16.00 WIB. Pesan yang masuk di luar
          jam layanan akan kami balas pada hari kerja berikutnya.
        </p>
      </div>
    </PublicShell>
  );
}
